export default __webpack_public_path__ + "93ad6e444e08201c002e122d6a8e596c.jpg";